// import Vue from 'vue'
// import App from './App.vue'
import empreinteCarbone from './components/features/simulateur/EmpreinteCarbone'

new Vue({
  el: '#simulateur-empreinte-carbone',
  render: h => h(empreinteCarbone)
});

